import { useContext, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { PluginContext } from 'ts-components/Plugins/context';
import { sendResultUpload } from 'ts-components/PiChat/presignedPut';
import { useFrameHandler } from '../useFrameHandler';
import {
  createKiCodeRefreshPlugins,
  refreshKiCodePlugins,
} from './refreshPlugins';

export const useKiCodeRefreshPlugins = (
  enabled: boolean,
  appApiName: string | undefined
) => {
  const plugins = useContext(PluginContext);
  const queryClient = useQueryClient();
  const latest = useRef({ plugins, queryClient, appApiName });
  latest.current = { plugins, queryClient, appApiName };

  return useFrameHandler(enabled, () =>
    createKiCodeRefreshPlugins({
      refresh: () =>
        refreshKiCodePlugins(
          latest.current.plugins,
          latest.current.queryClient,
          latest.current.appApiName
        ),
      sendResult: sendResultUpload,
    })
  ).handle;
};
